/** Construct url with parameters  */
export function getUrl(url: string, args: object): string {
  let newUrl = url;
  Object.entries(args).forEach(([key, value]): any => {
    newUrl = newUrl?.replace(`:${key}`, value);
  });
  return newUrl;
}
